
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomains/cvk/event/[eventId]/results",
      function () {
        return require("private-next-pages/_subdomains/cvk/event/[eventId]/results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomains/cvk/event/[eventId]/results"])
      });
    }
  